import { generateUniqueId } from ".";
import { BOT_ROLE, CONSENT_TYPE } from "../constants";
import { ResponseType } from "../types/apiTypes";

export const generateStarterMsg = (initialData: any, language: string) => {
  const isActiveConsent = initialData?.consentType === CONSENT_TYPE.ACTIVE;
  const enableLanguageToggle = initialData?.enableLanguageToggle;
  const { starterMessage = [], tnc } =
    initialData?.config?.translations?.[language] || {};

  const messages: any[] = [];

  starterMessage?.filter(Boolean)?.forEach((msgText: string) => {
    messages.push({
      role: BOT_ROLE,
      timestamp: new Date().toISOString(),
      id: generateUniqueId(),
      type: ResponseType.Text,
      body: { text: msgText || "" },
    });
  });

  if (isActiveConsent && tnc) {
    messages.push({
      role: BOT_ROLE,
      type: ResponseType.TNC,
      timestamp: new Date().toISOString(),
      id: generateUniqueId(),
      body: { ...tnc, allow_feedback: false },
      action_payload: {},
      feedback: "",
    });
  }
  if (enableLanguageToggle) {
    messages.push({
      role: BOT_ROLE,
      type: ResponseType.TranslationToggle,
      timestamp: new Date().toISOString(),
      id: generateUniqueId(),
      body: {},
      action_payload: {},
      feedback: "",
    });
  }

  return messages;
};
